<p-card>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu flex align-items-right">
      <div class="flex align-items-right" style="margin-left: auto;margin-right: 0;">

        <a class="fa fa-question-circle help-icon ml-1; margin-top: 25px;" pTooltip="Help" tooltipPosition="bottom"
          aria-hidden="true"  
          (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','17')"></a>
      </div>
    </div>
  </div>
  <form [formGroup]="modifyForm" id="modifyform">
    <div class="formgrid grid">
      <div class="field col-8">
        <div class="grid">
          <div class="col-12 lg:col-12 md:col-12 sm:col-12">
          </div>
        </div>
      </div>
    </div>

    <div class="formgrid grid">
      <div class="field col-8">
        <div class="grid">
          <div class="col-12 lg:col-8 md:col-8 sm:col-12">
            <p style="font-size: 1.3rem !important; font-weight: 600; color: black; margin-left: -3px;">Compliance
              Dashboard Configuration</p>
          </div>
        </div>
      </div>
    </div>

    <div class="formgrid grid" style="align-items: flex-end;">
      <div class="field col-5">
        <div class="grid">
          <div class="col-12">
            <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">
              Product for Top Menu
            </label>
            <p-multiSelect [options]="products" formControlName="products" optionLabel="productname"
              optionValue="productid" style="width: 160px !important;" [pTooltip]="getSelectedProductTooltip()"
              placeholder="Select Products">
            </p-multiSelect>
          </div>
        </div>
      </div>

      <div class="field col-3">
        <div class="grid">
          <div class="col-12">
            <label for="defaultProduct" style="font-size: 0.9rem !important; font-weight: 600; color: black;">Default
              Product</label>
            <p-dropdown [options]="productList" formControlName="defaultProduct" optionLabel="productname"
              optionValue="productid" pTooltip="{{ getDefaultProductTooltip(modifyForm.get('defaultProduct')?.value) }}"
              placeholder="Select a Product">
            </p-dropdown>
          </div>
        </div>
      </div>

      <div class="field col-2" style="display: flex; align-items: flex-end; margin-left: 8px;">
        <div class="col-12">
          <label style="visibility: hidden;">Action</label>
          <button type="button" class="btn btn-primary" (click)="productModify()">Modify</button>
        </div>
      </div>
    </div>

    <div class="grid" style="margin-top: -20px;">
      <div class="col-5 col-offset-5">
        <p style="color: red; font-size: 0.7rem !important; font-weight: 600;  margin: 0;">
          Please logout and login to see the change in the default product settings.
        </p>
      </div>
    </div>
    <hr>

    <div class="formgrid grid">
      <div class="field col-12">
        <div class="grid">
          <div class="col-12 lg:col-12 md:col-12 sm:col-12">
            <p style="font-size: 1.3rem !important; font-weight: 600; color: black; margin-bottom: 2px;">
              Please select Compliance Dashboard widgets you want to see, unselect to hide the widgets
            </p>
            <!-- <p style="font-size: 0.7rem !important; font-weight: 600; color: red; margin-top: 2px;">
              Click the Modify button listed against Monthly Email Report section to save these changes
            </p> -->
          </div>
        </div>
      </div>
    </div>

    <div class="formgrid grid">
      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;" for="cw1">Circular charts</label>
        <div class="dropdown-wrapper">
          <p-dropdown [options]="circularChartControl" inputId="circularChartControl" [filter]="true" appendTo="body"
            name="cw1" optionLabel="labelname" optionValue="value" formControlName="cw1"></p-dropdown>
        </div>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;" for="cw2">Calendar</label>
        <p-dropdown [options]="calendarControl" inputId="calendarControl" [filter]="true" appendTo="body" name="cw2"
          optionLabel="labelname" optionValue="value" formControlName="cw2"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;"
          for="complianceGraphControl">Compliance Graph</label>
        <p-dropdown [options]="complianceGraphControl" inputId="complianceGraphControl" [filter]="true" appendTo="body"
          name="cw3" optionLabel="labelname" optionValue="value" formControlName="cw3"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;" for="cw4">Non-Compliance
          Graph</label>
        <p-dropdown [options]="nonComplianceGraphControl" inputId="nonComplianceGraphControl" [filter]="true"
          appendTo="body" name="cw4" optionLabel="labelname" optionValue="value" formControlName="cw4"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">Entity-wise Graph</label>
        <p-dropdown [options]="entityControl" inputId="entityControl" [filter]="true" appendTo="body" name="cw8"
          optionLabel="labelname" optionValue="value" formControlName="cw8"></p-dropdown>
      </div>
    </div>

    <!-- 2nd row -->
    <div class="formgrid grid">

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">{{ verticalLabelName}}-wise
          Graph</label>
        <p-dropdown [options]="verticalControl" inputId="verticalControl" [filter]="true" appendTo="body" name="cw9"
          optionLabel="labelname" optionValue="value" formControlName="cw9"></p-dropdown>
      </div>

      <div *ngIf="userrole == 1 || userrole == 2" class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">Department-wise Graph</label>
        <p-dropdown [options]="departmentControl" inputId="departmentControl" [filter]="true" appendTo="body" name="cw6"
          optionLabel="labelname" optionValue="value" formControlName="cw6"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">Location-wise Graph</label>
        <p-dropdown [options]="locationControl" inputId="locationControl" [filter]="true" appendTo="body" name="cw7"
          optionLabel="labelname" optionValue="value" formControlName="cw7"></p-dropdown>
      </div>

      <div *ngIf="requireVertLabel == 'Y'" class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">{{customerLabelName }}-wise
          Graph</label>
        <p-dropdown [options]="customerControl" inputId="customerControl" [filter]="true" appendTo="body" name="cw11"
          optionLabel="labelname" optionValue="value" formControlName="cw11"></p-dropdown>
      </div>

      <div *ngIf="userrole != 1 && userrole != 2">
        <input name="cw6" value="N" type="hidden" />
        <input name="cw7" value="N" type="hidden" />
      </div>

      <div *ngIf="userrole == 1 || userrole == 2" class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">State-wise Graph</label>
        <p-dropdown [options]="stateControl" inputId="stateControl" [filter]="true" appendTo="body" name="cw12"
          optionLabel="labelname" optionValue="value" formControlName="cw12"></p-dropdown>
      </div>
    </div>

    <!-- 3rd row -->
    <div class="formgrid grid">

      <div *ngIf="isContractType === 'Y'" class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">{{ contractTypeLabel }}-wise
          Graph</label>
        <p-dropdown [options]="contractTypeControl" inputId="contractTypeControl" [filter]="true" appendTo="body"
          name="cw13" optionLabel="labelname" optionValue="value" formControlName="cw13"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">{{ labelowner }}-wise Graph</label>
        <p-dropdown [options]="ownerControl" inputId="ownerControl" [filter]="true" appendTo="body" name="cw14"
          optionLabel="labelname" optionValue="value" formControlName="cw14"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">{{ labelmanager }}-wise
          Graph</label>
        <p-dropdown [options]="managerControl" inputId="managerControl" [filter]="true" appendTo="body" name="cw15"
          optionLabel="labelname" optionValue="value" formControlName="cw15"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">Law Category-wise Graph</label>
        <p-dropdown [options]="lawCategoryControl" inputId="lawCategoryControl" [filter]="true" appendTo="body"
          name="cw17" optionLabel="labelname" optionValue="value" formControlName="cw17"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">Year-wise NonCompliance
          Graph</label>
        <p-dropdown [options]="yearWiseControl" inputId="yearWiseControl" [filter]="true" appendTo="body" name="cw18"
          optionLabel="labelname" optionValue="value" formControlName="cw18"></p-dropdown>
      </div>
    </div>

    <!-- 4th row -->
    <div class="formgrid grid">

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">{{ labelowner }} Rejection Wise
          Status</label>
        <p-dropdown [options]="ownerRejectionControl" inputId="ownerRejectionControl" [filter]="true" appendTo="body"
          name="cw19" optionLabel="labelname" optionValue="value" formControlName="cw19"></p-dropdown>
      </div>

      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">{{ labelmanager }} Rejection Wise
          Status</label>
        <p-dropdown [options]="managerRejectionControl" inputId="managerRejectionControl" [filter]="true"
          appendTo="body" name="cw20" optionLabel="labelname" optionValue="value" formControlName="cw20"></p-dropdown>
      </div>
      
      <div class="field col-7" style="display: flex; align-items: center;">
        <p style="font-size: 0.7rem !important; font-weight: 600; color: red; margin: 0.5rem 0 0 1rem;">
          Click the Modify button listed against Monthly Email Report section to save these changes
        </p>
      </div>
      <div class="field col-1">
      </div>
    </div>
    <hr>

    <div style="margin-top: -2px; " class="formgrid grid">
      <div class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">Monthly Email Report</label>
        <p-dropdown [options]="mailControl" (onChange)="emailToggle($event)" inputId="mailControl" [filter]="true"
          appendTo="body" name="cw16" optionLabel="labelname" optionValue="value" formControlName="cw16"></p-dropdown>
      </div>

      <div *ngIf="reportStatus == 'Y'" class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">Frequency (Periodic
          Interval)</label>
        <p-dropdown [options]="frequencyControl" inputId="frequencyControl" [filter]="true" appendTo="body"
          optionLabel="labelname" optionValue="value" formControlName="frequency"></p-dropdown>
      </div>

      <div *ngIf="reportStatus == 'Y'" class="field col-2">
        <label style="font-size: 0.9rem !important; font-weight: 600; color: black;">Day
          <span style="color: rgb(60, 137, 246);font-size:9px !important;">(Max 2 digits)</span>
          <span style="color: red;">*</span>
        </label>
        <input class="form-control" type="number" id="onday" formControlName="monthday" required name="monthday"
          placeholder="Enter Day" (input)="onDayInput($event)" />
      </div>


      <div class="field col-2" style="display: flex; align-items: flex-end; margin-left: 8px;">
        <div class="col-12">
          <label style="visibility: hidden;">Action</label>
          <button type="button" class="btn btn-primary" (click)="modify()">Modify</button>
        </div>
      </div>
    </div>

    <!-- <div class="formgrid grid">
      <div class="field col-12">
        <div class="grid">
          <div class="col-12 lg:col-12 md:col-12 sm:col-12">
            <p style="font-size: 1.6rem; font-weight: 500; color: black ">Verify Email Address for auto generated Emails
              (After successful verification, this email will be used as the sender for all auto generated emails in your organization.)</p>
          </div>
        </div>
      </div>
    </div>

    <div class="formgrid grid">
      <div class="field col-12">
        <div class="grid">
          <div class="col-12 lg:col-4 md:col-4 sm:col-12">
            <input type="email" id="email" name="email" class="form-control" [value]="emailaddress" readonly
              style="width: 10%;" />
          </div>
          <div class="col-12 lg:col-4 md:col-4 sm:col-12">
            <button type="submit" class="btn btn-primary" (click)="toggleEmailStatus()">{{emailButtonValue}}</button>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="formgrid grid">
      <div class="field col-12">
        <div class="grid">
          <div class="col-12 lg:col-12 md:col-12 sm:col-12">
            <p style="font-size: 1.6rem; font-weight: 500; color: black ">Verify Email Address for auto generated Emails
              (After successful verification, this email will be used as the sender for all auto generated emails in your organization.)</p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div class="formgrid grid">
      <div class="field col-12">
        <div class="grid">
          <div class="col-12 lg:col-4 md:col-4 sm:col-12">
            <input   #adminEmailInput type="email" id="adminEmail" name="adminEmail" class="form-control"  placeholder="Email Address"/>
        
          </div>
          <div class="col-12 lg:col-4 md:col-4 sm:col-12">
            <button type="button" class="btn btn-primary" (click)="verifyEmail(adminEmailInput.value)">Verify</button>
          </div>
        </div>
      </div>
    </div> -->
  </form>
</p-card>